import React, { useState } from "react";
import "../EditableField.css";

let hover = false;

const EditableField = (props) => {
  const [isActiveEdit, setIsActiveEdit] = useState(false);
  const [hovering, update] = useState(false);

  let current_value = props.editMode
    ? props.cv[props.field].default
    : props.cv[props.field].value;

    const handleHover = (isEditing, fieldToEdit) => {
      console.log(isEditing, fieldToEdit);
      props.handleHover(isEditing, fieldToEdit);
      setIsActiveEdit(true);
    }
  return (
    <div className='d-flex'>
      {props.editMode && isActiveEdit && props.type !== "file" ? (
        <div>
          {props.type !== "file" && (
            <div className="form-group">
              <label>
                <span
                  onClick={() => {
                    setIsActiveEdit(false);
                  }}
                >
                  <i className="fas fa-check pr-3"></i>
                </span>
                <input
                  type="text"
                  defaultValue={props.cv[props.field].default}
                  onKeyUp={(e) => {
                    let newvalue = {};
                    newvalue[props.field] = {
                      value: e.target.value,
                      default: e.target.value,
                    };
                    props.setCV({
                      ...props.cv,
                      ...newvalue,
                    });
                  }}
                />
              </label>
            </div>
          )}
        </div>
      ) : (
        <div
          onClick={() => {
            if (props.editMode) {
              handleHover(true, props.field)
            }
          }}
        >
          {props.type === "file" ? (
            <div
              onClick={() => {
                if (props.editMode) {
                  setIsActiveEdit(true);
                }
              }}
              className="avatar-wrapper"
              style={{ backgroundImage: `url(${current_value})` }}
            >
              {props.editMode && (
                <input
                  type="file"
                  onChange={(e) => {
                    if (e.target.files[0].type.indexOf("image") !== -1) {
                      let fr = new FileReader();
                      fr.addEventListener("load", (fre) => {
                        let newvalue = {};
                        newvalue[props.field] = {
                          value: fre.target.result,
                          default: fre.target.result,
                        };
                        props.setCV({
                          ...props.cv,
                          ...newvalue,
                        });
                      });
                      fr.readAsDataURL(e.target.files[0]);
                    } else {
                      alert("Invalid format =)");
                    }
                  }}
                />
              )}
            </div>
          ) : (
            current_value
          )}
        </div>
      )}
    </div>
  );
};

export default EditableField;
